module.exports = "<div class=uim-widget><div class=uim-valid-registration></div><div class=uim-invalid-registration></div><div class=uim-mfa></div></div>";


//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/html/UserRegistration.html
// module id = 42
// module chunks = 0